export default __webpack_public_path__ + "static/media/Cartilha_Antirracista.2be9545a.pdf";